import React, { useEffect, useMemo } from 'react';
import { CSSObject, Global } from '@emotion/react';
import { GlobalTypography } from '@cvent/carina/components/Typography/GlobalTypography';
import getConfig from 'next/config';
import useTheme from '@hooks/useTheme';

/**
 * Applies styles to the entire application
 */
export function GlobalStyles() {
  const { publicRuntimeConfig } = getConfig();
  const theme = useTheme();
  const { backgroundColor, additionalColor2, font } = theme;
  const customBackground = additionalColor2 || backgroundColor.surface;

  const globalStyles = useMemo<CSSObject>(
    () => ({
      '*': { boxSizing: 'border-box' },
      html: {
        height: '100%'
      },
      body: {
        backgroundColor: customBackground,
        height: '100%'
      },
      '#__next': {
        height: '100%'
      }
    }),
    [customBackground]
  );

  useEffect(() => {
    // Log the Carina theme object for reference
    if (
      publicRuntimeConfig.IS_DEV &&
      // Avoid printing during unit tests
      process.env.JEST_WORKER_ID === undefined
    ) {
      // eslint-disable-next-line no-console
      console.info(
        '%cCarina Theme Reference',
        `
      padding: .25rem .5rem;
      margin: .5rem 0;
      color: ${font.color.brand.base};
      font-family: ${font.base.family};
      font-size: ${font.base.size.s};
      background: ${backgroundColor.base};
      border-left: 4px solid ${backgroundColor.accent.fill.surface};
    `,
        theme
      );
    }
  }, [
    backgroundColor.accent.fill.surface,
    backgroundColor.base,
    font.base.family,
    font.base.size.s,
    font.color.brand.base,
    publicRuntimeConfig.IS_DEV,
    theme
  ]);

  return (
    <>
      <GlobalTypography />
      <Global styles={globalStyles} />
    </>
  );
}
